import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromBoosts from './+state';
import { BoostsEffects } from './+state/boosts.effects';
import { BoostsFacade } from './+state/boosts.facade';

@NgModule({
	imports: [
		StoreModule.forFeature(fromBoosts.BOOSTS_FEATURE_KEY, fromBoosts.boostsReducer),
		EffectsModule.forFeature([BoostsEffects]),
	],
	providers: [BoostsFacade],
})
export class EDRBoostsModule {}
